module.exports = __webpack_public_path__ + "static/media/travel-bg-right-2.355f5085.jpg";